<template>
  <div class="home">
    <!-- <div class="title-text">按需选择定制品类</div>
    <div class="class-list">
      <div @click="jumpProduct(item)" v-for="(item, index) of categoryList"
        style="display: flex;flex-direction: column;align-items: center;justify-content: center">
        <div class="class-list-box" :body-style="{ padding: '0px' }">
          <div class="box-img">
            <el-skeleton :loading="!item.isLoaded" animated>
              <template #template>
                <el-skeleton-item variant="image" style="width: 228px; height: 228px" />
              </template>
</el-skeleton>
<el-image @load="item.isLoaded = true" @error="item.isLoaded = true" :src="item.categoryImage" class="zoom-image">
  <template #error>
                <div style="height: 100%;height: 100%;display: flex;justify-content: center;align-items: center">
                  <div>{{ t('common.loading_failed') }}</div>
                </div>
              </template>
</el-image>
</div>
</div>
<div class="box-text">{{ item.categoryName }}</div>
</div>
</div> -->
    <!-- <div style="position: absolute; top: 200px;height: 340px;width: 1200px; z-index: 7; border-radius: 4px;"
      id="baiduMap">
    </div> -->
    <div
      style="margin-top: 10px; width: 1200px;height: 200px;background: linear-gradient(0deg, #FAFAFA, #FAFAFA);border-radius: 4px;">
      <img style="width:100%; cursor: pointer;" @click="jumpMap" src="../assets/image/banner2.png" alt="">
    </div>
    <div style="display: flex;justify-content: space-between;align-items: center;margin: 20px 0 10px 0">
      <div style="display: flex;align-items: center">
        <img style="width: 36px; height: 36px;" src="../assets/image/dsyc.png" alt="">
        <div class="sub-text">{{ t('home.artist_original') }}</div>
      </div>
      <!-- <div class="more-text" @click="jumpCasualClothing">
        More <img style="margin-left: 3px;" src="../assets/image/more-icon.png" alt="">
      </div> -->
    </div>

    <div class="sub-list" style="display: grid;gap: 14px;grid-template-columns: repeat(auto-fill, minmax(224px, 1fr))">
      <div class="sub-list-box" v-for="(item, i) of productList" v-bind:key="item" :body-style="{ padding: '0px' }"
        @mouseover="selectIndex = i" @mouseleave="selectIndex = -1">
        <div v-if="item.designImageDtoList[0].previewUrl" @click="jumpDetail(item)">
          <div v-show="selectIndex == i" class="sub-list-box-img" style="position: relative;">
            <el-image
              style="position: absolute;z-index: 11;width: 100%; height: 100%; display:flex; justify-content: center; align-items: center; z-index: 7"
              :src="getDesignImg(item, 1)" class="feathered-image zoom-image"></el-image>
          </div>
          <div v-show="selectIndex != i" class="sub-list-box-img" style="position: relative;">
            <el-skeleton :loading="!item.isLoaded" animated>
              <template #template>
                <el-skeleton-item variant="image" style="width: 224px; height: 224px" />
              </template>
            </el-skeleton>
            <el-image @load="item.isLoaded = true" @error="item.isLoaded = true"
              style="width: 100%;height: 100%;  display:flex; justify-content: center; align-items: center;"
              :src="item.designImageDtoList[0].previewUrl" class="feathered-image zoom-image">
              <template #error>
                <div style="height: 100%;height: 100%;display: flex;justify-content: center;align-items: center">
                  <div>{{ t('common.loading_failed') }}</div>
                </div>
              </template>
            </el-image>
          </div>
        </div>
        <div v-else>
          <div v-show="selectIndex == i" class="sub-list-box-img" @click="jumpDetail(item)" style="position: relative;">
            <el-image style="position: absolute;z-index: 11;width: 100%;height: 100%;z-index: 7"
              :src="getDesignImg(item, 1)" class="feathered-image zoom-image"></el-image>
          </div>
          <div v-show="selectIndex != i" class="sub-list-box-img" @click="jumpDetail(item)" style="position: relative;">
            <el-skeleton :loading="!item.isLoaded" animated>
              <template #template>
                <el-skeleton-item variant="image" style="width: 224px; height: 224px" />
              </template>
            </el-skeleton>
            <el-image @load="item.isLoaded = true" @error="item.isLoaded = true" :src="item.productImageUrl">
              <template #error>
                <div style="height: 100%;height: 100%;display: flex;justify-content: center;align-items: center">
                  <div>{{ t('common.loading_failed') }}</div>
                </div>
              </template>
            </el-image>
            <el-image style="position: absolute;z-index: 11;width: 30%;height: 30%;z-index: 7"
              :src="getDesignImg(item, 1)" class="feathered-image"></el-image>
          </div>
        </div>
        <div class="sub-list-box-text">
          <div class="box-title">{{ item.designName }}</div>
          <div class="box-price">￥{{ item.totalAmount }}&nbsp;&nbsp;<span>{{ t('home.sold') }} {{ item.salesVolume }}</span>
            <div style="display: flex; align-items: center; margin-left: 10px;" @click.stop="handleProductLike(item)">
              <img v-if="item.followFlag === 0" src="../assets/home/wdz.png" alt="">
              <img v-else src="../assets/home/ydz.png" alt="">
              <span style="margin-left: 3px; margin-top: 3px;">{{ item.followerCount }}</span>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div style="width: 100%; display: flex; justify-content: center; margin-top: 10px;">
      <div class="more-btn" @click="jumpCasualClothing">{{ t('home.view_more') }}</div>
    </div>
    <!-- {{ t('home.lottery_ad') }} -->
    <div v-if="lotteryInfo"
      style="width: 100%; display: flex; justify-content: center; margin: 30px 0 0 0; position: relative;">
      <img :src="lotteryInfo ? lotteryInfo.lotteryDecsImage : '@/assets/lottery/home-bg.png'"
        style="cursor: pointer; width: 100%; max-width: 1200px; border-radius: 16px; min-height: 80px; object-fit: cover;"
        @click="jumpLottery" :alt="t('home.lottery_ad')" />
      <img v-if="showBreathingIcon" src="@/assets/lottery/home-bg2.png"
        style="position: absolute; right: 230px; top: calc(50% - 10px); transform: translateY(-50%); width: 160px; height: 160px; animation: breathing 2.5s ease-in-out infinite; cursor: pointer;"
        :style="{ opacity: breathingIconOpacity, transition: 'opacity 1s' }" :alt="t('home.breathing_icon')" @click="jumpLottery" />
    </div>

    <div style="display: flex;justify-content: space-between;align-items: center;margin: 40px 0 10px 0">
      <div style="display: flex;align-items: center">
        <img style="width: 36px; height: 36px;" src="../assets/image/rmcz2.png" alt="">
        <div class="sub-text">{{ t('home.hot_creation') }}</div>
      </div>
      <!-- <div class="more-text" @click="jumpGallery">
        More <img style="margin-left: 3px;" src="../assets/image/more-icon.png" alt="">
      </div> -->
    </div>

    <div class="sub-list">
      <div @click="jumpClassDetail(item)" class="sub-list-box" v-for="item of ArtisArtworkList" v-bind:key="item"
        :body-style="{ padding: '0px' }">
        <div class="sub-list-box-img">
          <el-skeleton :loading="!item.isLoaded" animated>
            <template #template>
              <el-skeleton-item variant="image" style="width: 224px; height: 224px" />
            </template>
          </el-skeleton>
          <el-image @load="item.isLoaded = true" @error="item.isLoaded = true" style="width: 100%"
            :src="getThumbnailUrl(item.artFileUrl)" class="zoom-image">
            <template #error>
              <div style="height: 100%;height: 100%;display: flex;justify-content: center;align-items: center">
                <div>{{ t('common.loading_failed') }}</div>
              </div>
            </template>
          </el-image>
        </div>
        <div class="sub-list-box-text">
          <div class="box-title">{{ item.artTitle }}</div>
          <div class="box-price">￥{{ item.imagePriceRmb }}&nbsp;&nbsp;<span>{{ t('home.used') }} {{ item.salesVolume }}</span></div>
        </div>
      </div>
    </div>
    <div style="width: 100%; display: flex; justify-content: center; margin-top: 10px;">
      <div class="more-btn" @click="jumpGallery">{{ t('home.view_more') }}</div>
    </div>

    <div style="display: flex;justify-content: space-between;align-items: center;margin: 40px 0 10px 0">
      <div style="display: flex;align-items: center">
        <img style="width: 36px; height: 36px;" src="../assets/image/rmdp.png" alt="">
        <div class="sub-text">{{ t('home.hot_shop') }}</div>
      </div>
    </div>
    <div class="sub-list">
      <div class="arrow-btn left" @click="prevPage" :class="{ disabled: currentPage === 0 }">
        <img src="../assets/image/left-icon.png" alt="">
      </div>
      <div @click="jumpCreatorDetail(item)" class="sub-list-box" v-for="(item, i) in creatorList" v-bind:key="item"
        :body-style="{ padding: '0px' }" @mouseover="selectIndex = i" @mouseleave="selectIndex = -1">
        <div class="sub-list-box-img" style="position: relative;"
          v-for="(img, index) in item.artistArtworkRespList.slice(0, 1)" :key="index">
          <el-skeleton :loading="!item.isLoaded" animated>
            <template #template>
              <el-skeleton-item variant="image" style="width: 224px; height: 224px" />
            </template>
          </el-skeleton>
          <el-image @load="item.isLoaded = true" @error="item.isLoaded = true"
            style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;"
            :src="getThumbnailUrl(img.artFileUrl)" class="zoom-image shop-img">
            <template #error>
              <div style="height: 100%;height: 100%;display: flex;justify-content: center;align-items: center">
                <div>{{ t('common.loading_failed') }}</div>
              </div>
            </template>
          </el-image>
          <div v-if="selectIndex == i" class="hot-shop-like" @click.stop="addOrRemoveHeart(item)">
            <img v-if="item.followFlag === 0" src="../assets/home/heart.png" alt="">
            <img v-else src="../assets/home/ygz.png" style="cursor: pointer">
          </div>
        </div>
        <div class="sub-list-box-text" style="align-items: center">
          <div class="box-title" style="font-weight: bold;">{{ item.nickname }}</div>
          <div class="box-price" style="display: flex; align-items: center;"><span>{{ t('home.fans') }} {{ item.followerCount }}</span>
            <div class="split"></div><span>{{ t('home.sales') }} {{ item.salesVolume }}</span>
          </div>
        </div>
      </div>
      <div class="arrow-btn right" @click="nextPage" :class="{ disabled: currentPage >= totalPages - 1 }">
        <img src="../assets/image/right-icon.png" alt="">
      </div>
    </div>
    <br /><br />
    <!-- <div class="sub-list">
      <div class="box-card-creator" v-for="item of creatorList" v-bind:key="item" shadow="hover">
        <div class="card-header" style="margin-bottom: 20px">
          <div @click="jumpCreatorDetail(item)" style="display: flex;align-items: center;cursor: pointer">
            <div
              style="width: 56px;height: 56px;border-radius: 100%;background-color: #E8EAED;overflow: hidden;  box-shadow: 0 2px 4px rgba(0,0,0,0.3);">
              <img style="width: 100%" :src="item.headImg">
            </div>
            <div class="user-text">{{ item.nickname }}</div>
          </div>
          <div style="display: flex;align-items: center;justify-content: center">
            <img @click="jumpCreatorDetail(item)" src="../assets/home/home.png"
              style="margin-right: 20px;cursor: pointer">
            <img @click="addOrRemoveHeart(item)" v-if="item.followFlag === 0" src="../assets/home/heart.png"
              style="margin-right: 5px;cursor: pointer">
            <img @click="addOrRemoveHeart(item)" v-else src="../assets/home/heart2.png"
              style="margin-right: 5px;cursor: pointer">
            <div style="font-size: 14px;color: #666;cursor: pointer">{{ item.followerCount }}</div>
          </div>
        </div>
        <div style="width: 100%;display: flex;justify-content: space-between">
          <div @click="jumpClassDetail(img)" v-for="(img, index) in item.artistArtworkRespList.slice(0, 3)" :key="index"
            style="width: 180px;height: 180px;background-color: #E8EAED;cursor: pointer;overflow: hidden;display: flex;justify-content: center;align-items: center">
            <el-skeleton :loading="!img.isLoaded" animated>
              <template #template>
                <el-skeleton-item variant="image" style="width: 180px; height: 180px" />
              </template>
            </el-skeleton>
            <el-image @load="img.isLoaded = true" @error="img.isLoaded = true" v-if="index < 3" style="width: 100%"
              :src="img.artFileUrl" class="zoom-image">
              <template #error>
                <div style="height: 100%;height: 100%;display: flex;justify-content: center;align-items: center">
                  <div>加载失败</div>
                </div>
              </template>
            </el-image>
          </div>
        </div>
      </div>
    </div> -->

    <!-- <div style="margin-top: 20px;height: 40px">
      <div style="font-size: 16px;color: #999;">
        Fungoo @ 2025 - All rights reserved
      </div>
    </div> -->
    <!--    <el-backtop :right="((screenWidth - 1200) / 2) - 60" :bottom="200" />-->
  </div>
</template>

<script>

import { nextTick, onMounted, ref, computed } from "vue";
import router from "@/router";
import { ElMessage } from "element-plus";
import {
  addHeart,
  cancelHeart,
  getArtisArtworkList,
  getArtisArtworkListHome, getCategory,
  getCreatorList,
  getCreatorListHome,
  getProductList,
  getDesignProductList,
  addProductLike,
  cancelProductLike,
  getLotteryList
} from "@/api/api";
import { getThumbnailUrl } from '@/util/index'
import { useI18n } from 'vue-i18n'


export default {
  name: 'HomeView',
  components: {
    // HeaderMenu
  },
  setup() {
    const { t } = useI18n()
    
    const productList = ref([])
    const ArtisArtworkList = ref([])
    const creatorList = ref([])
    const categoryList = ref([])
    const selectIndex = ref(-1)
    const lotteryInfo = ref(null)

    // 心脏跳动广告延迟渐显相关变量
    const showBreathingIcon = ref(false)
    const breathingIconOpacity = ref(0)

    // 滑动相关变量
    const currentSlideIndex = ref(0)
    const slideWidth = 240 // 每个店铺卡片的宽度（包含margin）
    const maxSlideIndex = ref(0)
    const itemsPerRow = 5 // 每行显示的店铺数量
    const currentPage = ref(0)
    const searchCreatorParams = ref({
      pageNum: 1,
      pageSize: 5
    })
    const total = ref(0)
    const totalPages = computed(() => Math.ceil(total.value / itemsPerRow))
    onMounted(() => {
      localStorage.removeItem('pageNum')
      localStorage.removeItem('imgPageNum')
      getCategory({ shopId: 1 }).then(res => {
        categoryList.value = res
      }).catch(res => { })

      getArtisArtworkListHome({ pageNum: 1, pageSize: 20 }).then(res => {
        ArtisArtworkList.value = res.records.map(item => ({
          ...item,
          imagePriceRmb: (item.imagePriceRmb / 100).toFixed(2)
        }));
      }).catch(res => { });

      initProductList()
      getCreatorList()
      // 获取抽奖列表
      getLotteryList({ isDelete: 0, platformId: 1, lotteryStatus: 1, status: 1 }).then(res => {
        if (res.records && res.records.length > 0) {
          lotteryInfo.value = res.records[0]
        }
      }).catch(res => { })

      // 心脏跳动广告延迟渐显
      setTimeout(() => {
        showBreathingIcon.value = true
        setTimeout(() => {
          breathingIconOpacity.value = 1
        }, 50)
      }, 1000)
    })

    const getCreatorList = () => {
      searchCreatorParams.value.pageNum = currentPage.value + 1
      getCreatorListHome(searchCreatorParams.value).then(res => {
        creatorList.value = res.records
        total.value = res.total
        // 计算最大滑动索引：总数量 - 每行显示的数量
        // maxSlideIndex.value = Math.max(0, res.records.length - itemsPerRow)
        // console.log('creatorList length:', res.records.length)
        // console.log('maxSlideIndex:', maxSlideIndex.value)
        // console.log('Total pages:', Math.ceil(res.records.length / itemsPerRow))
      }).catch(res => { })
    }

    function initialize() {
      console.log('1233')
    }
    const initProductList = () => {
      getDesignProductList({ pageNum: 1, pageSize: 20, approveStatus: 1 }).then(res => {
        productList.value = res.records.map(item => ({
          ...item,
          totalAmount: (item.totalAmount / 100).toFixed(2)
        }));
      }).catch(res => { })
    }
    const screenWidth = ref(window.innerWidth)
    const classType = ref(0)


    //encodeURIComponent
    const menuIndex = ref(0)
    const changeMenu = (index) => {
      menuIndex.value = index
      if (index == 0) {
        initProductList()
      }
    }
    const jumpCreator = () => {
      router.push('/creatorMore')
    }
    const jumpGallery = () => {
      router.push('/galleryMore')
    }
    const jumpHot = () => {
      router.push('/hotMore')
    }


    const jumpDetail = (item) => {
      let colorName = item.skuList[0].properties.substring(item.skuList[0].properties.indexOf("颜色:") + 3)
      let cName = ''
      if (colorName.indexOf(";") == -1) {
        cName = colorName
      }
      else {
        cName = colorName.substring(0, colorName.indexOf(";"))
      }
      // 从 item 中直接提取 coverImageUrl，若不存在则回退从 designImageDtoList 中获取
      let coverImageUrl = (item && item.coverImageUrl && item.coverImageUrl !== 'null') ? item.coverImageUrl : null
      if (!coverImageUrl) {
        try {
          const dList = item?.designImageDtoList
          if (Array.isArray(dList) && dList.length > 0) {
            const c = dList[0]?.coverImageUrl
            if (c && c !== 'null') coverImageUrl = c
          }
        } catch (e) {}
      }
      //type 1单品详情 2定制详情
      router.push({ path: '/goodsDetail', query: { prodId: item.productId, colorName: cName, skuId: item.skuList[0].skuId, type: 1, followFlag: item.followFlag, followerCount: item.followerCount, designId: item.designId, picPrice: item.totalAmount, designFileUrl: getDesignImg(item, 2), shopId: item.shopId, shopName: item.shopName, designImageDtoList: JSON.stringify(item.designImageDtoList), oriPrice: item.oriAmount, coverImageUrl } })
    }
    const jumpClassDetail = (item) => {
      router.push({ path: '/product', query: { artId: item.artId } })
    }
    const jumpCreatorDetail = (item) => {
      router.push({ path: '/creator', query: { creatorId: item.creatorId } })
    }
    const jumpProduct = (item) => {
      router.push({ path: '/product', query: { categoryId: item.categoryId } })
    }

    const addOrRemoveHeart = (item) => {
      if (!localStorage.getItem('token')) {
        ElMessage.error(t('common.please_login'))
        return
      }
      if (item.followFlag === 1) {
        cancelHeart(item.creatorId).then(res => {
          ElMessage.success(t('creator.cancel_follow_success'))
          item.followFlag = 0
          item.followerCount = item.followerCount - 1
        })
      } else {
        addHeart(item.creatorId).then(res => {
          ElMessage.success(t('creator.follow_success'))
          item.followFlag = 1
          item.followerCount = item.followerCount + 1
        })
      }
    }

    const handleProductLike = (item) => {
      if (!localStorage.getItem('token')) {
        ElMessage.warning(t('common.please_login'))
        return
      }
      if (item.followFlag === 1) {
        cancelProductLike({ designId: item.designId }).then(res => {
          ElMessage.success(t('hot.cancel_like_success'))
          item.followFlag = 0
          item.followerCount = item.followerCount - 1
        }).catch(res => { })
      } else {
        addProductLike({ designId: item.designId }).then(res => {
          ElMessage.success(t('hot.like_success'))
          item.followFlag = 1
          item.followerCount = item.followerCount + 1
        }).catch(res => { })
      }
    }

    const jumpMap = () => {
      router.push({ path: '/map' })
    }

    const getDesignImg = (item, type) => {
      let str = ''
      if (item.designImageDtoList && item.designImageDtoList[0] && item.designImageDtoList[0].artId) {
        if (type == 1) {
          str = getThumbnailUrl(item.designImageDtoList[0].artUrl)
        }
        else {
          str = item.designImageDtoList[0].artUrl
        }
      }
      else if (item.designImageDtoList && item.designImageDtoList[0] && item.designImageDtoList[0].localImageId) {
        if (type == 1) {
          str = getThumbnailUrl(item.designImageDtoList[0].localImageUrl)
        }
        else {
          str = item.designImageDtoList[0].localImageUrl
        }
      }
      return str
    }

    const jumpCasualClothing = () => {
      // 动态查找"休闲服"分类的categoryId
      const casualClothingCategory = categoryList.value.find(item => item.categoryName === '休闲服')
      if (casualClothingCategory) {
        // 计算菜单索引：首页(0) + 分类在categoryList中的索引 + 1
        const categoryIndex = categoryList.value.findIndex(item => item.categoryName === '休闲服')
        const menuIndex = 1 + categoryIndex // 首页占索引0，所以分类从索引1开始
        router.push(`/hotMore?categoryId=${casualClothingCategory.categoryId}&index=${menuIndex}`)
      } else {
        // 如果找不到，使用默认值
        router.push('/hotMore?categoryId=1&index=1')
      }
    }

    // 滑动函数
    const slideLeft = () => {
      if (currentSlideIndex.value > 0) {
        currentSlideIndex.value--
        console.log('向左滑动，当前索引:', currentSlideIndex.value)
      }
    }

    const slideRight = () => {
      const totalPages = Math.ceil(creatorList.value.length / itemsPerRow)
      if (currentSlideIndex.value < totalPages - 1) {
        currentSlideIndex.value++
        console.log('向右滑动，当前索引:', currentSlideIndex.value)
      }
    }

    const jumpLottery = () => {
      // if (!localStorage.getItem('token')) {
      //   ElMessage.warning('请先登录后再进行抽奖')
      //   return
      // }
      if (lotteryInfo.value && lotteryInfo.value.lotteryId) {
        router.push({ path: '/lottery', query: { lotteryId: lotteryInfo.value.lotteryId } })
      } else {
        router.push('/lottery')
      }
    }

    const prevPage = () => {
      if (currentPage.value > 0) {
        currentPage.value--
        getCreatorList()
      }
    }

    const nextPage = () => {
      if (currentPage.value < totalPages.value - 1) {
        currentPage.value++
        getCreatorList()
      }
    }

    return {
      t,
      totalPages,
      prevPage,
      nextPage,
      currentPage,
      getDesignImg,
      jumpMap,
      jumpClassDetail,
      jumpProduct,
      addOrRemoveHeart,
      jumpCreatorDetail,
      creatorList,
      ArtisArtworkList,
      jumpDetail,
      productList,
      screenWidth,
      jumpHot,
      jumpGallery,
      jumpCreator,
      jumpCasualClothing,
      changeMenu,
      menuIndex,
      classType,
      categoryList,
      selectIndex,
      handleProductLike,
      getThumbnailUrl,
      // 滑动相关
      currentSlideIndex,
      maxSlideIndex,
      slideWidth,
      itemsPerRow,
      slideLeft,
      slideRight,
      jumpLottery,
      lotteryInfo,
      showBreathingIcon,
      breathingIconOpacity
    }
  }
}
</script>

<style scoped>
:deep(.el-image__inner) {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
}
</style>
<style lang="scss">
.shop-img {
  img {
    max-width: 100%;
    max-height: 100%;
    width: auto !important;
    height: auto !important;
  }
}

.el-message {
  top: 40% !important;
}

.el-message__content {
  font-size: 16px !important;
}

#map {
  width: 800px;
  height: 500px;
}

.home {
  //overflow-y: auto;
  width: 1200px;
  height: calc(100% - 60px);

  .more-btn {
    cursor: pointer;
    width: 300px;
    height: 44px;
    border-radius: 4px;
    border: 1px solid #CCCCCC;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
  }

  .more-btn:hover {
    background: #E5E5E5;
  }

  .arrow-btn {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s;
    z-index: 9;
    position: absolute;
    top: 40%;
    transform: translateY(-50%);

    &:hover:not(.disabled) {
      background: #f5f5f5;
    }

    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
      box-shadow: none;
    }

    &.left {
      left: -15px;
    }

    &.right {
      right: -15px;
    }
  }

  .title-text {
    font-size: 24px;
    color: #333;
    font-weight: bold;
    width: 100%;
    text-align: center;
    margin: 40px 0 20px 0;
  }

  .class-list {
    display: flex;
    justify-content: space-between;

    .class-list-box {
      width: 228px;
      border-radius: 30px;
      cursor: pointer;

      .box-img {
        width: 228px;
        height: 228px;
        background-color: #fff;
        border-radius: 30px;

      }
    }

    .box-text {
      width: 100%;
      text-align: center;
      margin-top: 10px;
      font-size: 16px;
      color: #333;
    }
  }

  .sub-text {
    font-weight: 400;
    font-size: 24px;
    color: #333333;
    margin-left: 10px;
  }

  .more-text {
    cursor: pointer;
    font-family: Acumin Variable Concept;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
  }

  .sub-class-item {
    width: 70px;
    height: 30px;
    background: #FFF;
    border-radius: 15px;
    font-weight: 400;
    font-size: 14px;
    color: #000;
    line-height: 30px;
    text-align: center;
    margin: 0 6px;
  }

  .sub-class-item-sel {
    background: #2371FF;
    color: #fff;
  }

  .sub-list {
    display: flex;
    // justify-content: space-between;
    flex-wrap: wrap;
    position: relative;

    .sub-list-box:hover {
      background-color: #fff;
      border-radius: 4px;
      box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.3);

      .sub-list-box-img {
        background: #fff !important;
      }
    }

    .sub-list-box {
      width: 240px;
      height: 290px;
      margin-bottom: 14px;
      cursor: pointer;

      .sub-list-box-img {
        height: 224px;
        width: 224px;
        border-radius: 4px;
        margin: 8px;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        // background: #fff;
        // background: linear-gradient(0deg, #FAFAFA, #FAFAFA);
        background: #f2f2f2;
      }

      .hot-shop-like {
        position: absolute;
        top: 8px;
        right: 8px;
        width: 34px;
        height: 34px;
        background: #FFFFFF;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;

      }

      .zan {
        position: absolute;
        top: 8px;
        right: 8px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 34px;
        height: 34px;
        background: #FFFFFF;
        border-radius: 4px;
        font-weight: 400;
        font-size: 10px;
        color: #333333;
        cursor: pointer;
        z-index: 12;

        img {
          width: 20px;
          height: 20px;
          margin-bottom: 2px;
        }

        span {
          transition: color 0.3s ease;
        }
      }

      .sub-list-box-text {
        width: 224px;
        height: 60px;
        display: flex;
        flex-direction: column;
        // align-items: center;

        .box-title {
          font-weight: 400;
          font-size: 14px;
          color: #333333;
          margin-left: 8px;
          // margin: 10px 0 5px 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .box-price {
          margin-top: 2px;
          margin-left: 8px;
          font-weight: bold;
          font-size: 14px;
          color: #333333;
          display: flex;
          align-items: center;

          span {
            font-weight: 400;
            font-size: 12px;
            color: #999999;
          }

          .split {
            margin-left: 20px;
            margin-right: 20px;
            width: 2px;
            height: 10px;
            background: #CCCCCC;
          }
        }
      }

      .sub-list-box-text2 {
        width: 204px;
        margin: 0 20px;
        height: 60px;

        .box-title {
          font-weight: bold;
          font-size: 18px;
          color: #010101;
          margin: 10px 0 5px 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .user-text {
          font-weight: 400;
          font-size: 12px;
          color: #999;
          margin-left: 6px;
        }

        .user-price {
          font-weight: 400;
          font-size: 14px;
          color: #000000;
        }
      }
    }

    .sub-list-box2 {
      height: 256px;
      width: 555px;
      background-color: #fff;
      border-radius: 15px;
      margin-top: 14px;

      padding: 10px 20px 20px 20px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .introduce-box {
        height: 72px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .user-text {
          margin-left: 10px;
          font-weight: 400;
          font-size: 16px;
          color: #000000;
        }
      }

      .img-box {
        height: 180px;
        display: flex;
        justify-content: space-between;

        .img-item {
          width: 180px;
          height: 180px;
          background-color: #E8EAED;
        }
      }
    }
  }
}

.box-card-creator {
  margin-top: 4px;
  margin-bottom: 10px;
  border-radius: 20px !important;
  background-color: #fff;
  padding: 20px;
  /*display: flex;*/
  /*justify-content: space-between;*/
  width: 550px
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.user-text {
  font-size: 16px;
  color: #000;
  margin-left: 20px;
}

.zoom-image {
  width: 100%;
  height: auto;
  transition: transform 0.3s ease;
  /* 设置过渡动画 */
}

.zoom-image:hover {
  transform: scale(1.2);
  /* 鼠标移入放大 1.2 倍 */
}

.feathered-image {
  -webkit-mask-image: radial-gradient(circle, rgba(0, 0, 0, 1) 50%, rgba(0, 0, 0, 0) 100%);
  mask-image: radial-gradient(circle, rgba(0, 0, 0, 1) 50%, rgba(0, 0, 0, 0) 100%);
}

// 滑动相关样式
.creator-slider-container {
  width: 1200px;
  position: relative;
}

.creator-slider-wrapper {
  width: 1200px;
  height: 320px;
  overflow: hidden;
  position: relative;
  padding: 15px 0;
}

.creator-slider {
  display: flex;
  flex-wrap: nowrap;
  transition: transform 0.3s ease;
  width: max-content;
  height: 290px;
  gap: 0;
}

.creator-slider .sub-list-box {
  flex-shrink: 0;
  margin-right: 0;
  width: 240px;
}

.slide-btn-left,
.slide-btn-right {
  position: absolute;
  top: calc(50% - 48px);
  transform: translateY(-50%);
  transition: all 0.3s ease;
  z-index: 100;
}

.slide-btn-left {
  left: -16px;
}

.slide-btn-right {
  right: -16px;
}

.slide-btn-left:hover,
.slide-btn-right:hover {
  transform: translateY(-50%) scale(1.1);
}

.slide-btn-left.disabled,
.slide-btn-right.disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.slide-btn-left.disabled:hover,
.slide-btn-right.disabled:hover {
  transform: translateY(-50%);
}

@keyframes breathing {
  0% {
    transform: translateY(-50%) scale(1);
  }

  50% {
    transform: translateY(-50%) scale(1.25);
  }

  100% {
    transform: translateY(-50%) scale(1);
  }
}
</style>
